import { render, staticRenderFns } from "./ComboboxGroupSolution.vue?vue&type=template&id=0532c07a"
import script from "./ComboboxGroupSolution.vue?vue&type=script&lang=js"
export * from "./ComboboxGroupSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports